export class BrandLogo {
  private static instance: BrandLogo;
  constructor() {
    this.brandLogoClickHandler();
  }
  public static getInstance(): BrandLogo {
      if (!BrandLogo.instance) {
        BrandLogo.instance = new BrandLogo();
      }
      return BrandLogo.instance;
  }

  public brandLogoClickHandler(): void {
    const logoWrapper = document.querySelector('.brand-logo-wrapper') as HTMLAnchorElement;

  }
}
if (!(globalThis as any).__BrandLogoInitialized) {
    (globalThis as any).__BrandLogoInitialized = true;
    BrandLogo.getInstance();
}